import { FunctionComponent } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';
import { trackEvent } from 'dibs-tracking';
import { Link } from 'dibs-elements/exports/Link';
import styles from './SharedPopularSearchesLink.scss';
import type { SharedPopularSearchesLink_popularSearchesLink } from './__generated__/SharedPopularSearchesLink_popularSearchesLink.graphql';

type Props = {
    popularSearchesLink: SharedPopularSearchesLink_popularSearchesLink;
    popularSearchTermClassName?: string;
    isTopPlacement?: boolean;
};

export const SharedPopularSearchesLinkComponent: FunctionComponent<Props> = ({
    popularSearchesLink,
    popularSearchTermClassName,
    isTopPlacement,
}) => {
    if (!popularSearchesLink?.text || !popularSearchesLink?.path) {
        return null;
    }

    const { text, path } = popularSearchesLink;

    return (
        <div className={styles.popularSearches}>
            <Link
                href={path}
                dataTn="popular-searches-link"
                onClick={() =>
                    trackEvent({
                        category: 'promo interaction',
                        action: `mwtb popular searches link click${isTopPlacement ? ' - top' : ''}`,
                        label: `View All Popular ${text} Searches`,
                    })
                }
            >
                <FormattedMessage
                    id="SharedPopularSearchesLink.linkText"
                    defaultMessage="View All Popular <span>Category</span> Searches"
                    values={{
                        span: () => (
                            <span
                                className={
                                    popularSearchTermClassName || styles.popularSearchesCategory
                                }
                            >
                                {text}
                            </span>
                        ),
                    }}
                />
            </Link>
        </div>
    );
};

export const SharedPopularSearchesLink = createFragmentContainer(
    SharedPopularSearchesLinkComponent,
    {
        popularSearchesLink: graphql`
            fragment SharedPopularSearchesLink_popularSearchesLink on LinkData {
                text
                path
            }
        `,
    }
);
